// eslint-disable-next-line no-restricted-imports
import { MutationInput_ClientController_SaveOnboardingStatus_Input_Value as ClientOnboardingStatusTypeApi } from 'api/generated/graphql';
import { ClientOnboardingStatusType } from 'api/types/entity';

export const parseClientOnboardingStatusParam = (
  onboardingStatus: ClientOnboardingStatusType
): ClientOnboardingStatusTypeApi =>
  ClientOnboardingStatusTypeApi[onboardingStatus] ||
  ClientOnboardingStatusTypeApi.FillingOut;
